import React from 'react'

const Granizo = ({iconContactoMasculino}) => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" style={{"margin-bottom":"30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Área de Granizo</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Juan Vasquez</strong><br/>
                        0388 - 4911741 Int.: 147<br/>
                        jvasquez@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>José Bolivar</strong><br/>
                           0388 - 4911741 Int.: 142<br/>
                           granizo@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Esteban Torrico</strong><br/>
                        0388 - 4911741 Int.: 146<br/>
                        granizo@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Granizo